import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Smartphone, Wallet, Clock } from "lucide-react";

const MobilePaymentModal = ({
  open,
  onOpenChange,
  pendingInvoiceData,
  selectedClient,
  formatPrice,
  onKkiapay,
  onWallet,
  onPayLater,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-800 border-slate-700 text-white max-w-md" data-testid="mobile-payment-modal">
        <DialogHeader>
          <DialogTitle className="text-amber-500 text-xl">Paiement Mobile Money</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="text-center mb-4">
            <p className="text-slate-400">Montant à payer</p>
            <p className="text-3xl font-bold text-amber-500">
              {formatPrice(pendingInvoiceData?.total || 0)} FCFA
            </p>
          </div>

          <div className="space-y-3">
            {/* Kkiapay Option */}
            <Button
              onClick={onKkiapay}
              className="w-full h-16 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white"
              data-testid="mobile-pay-kkiapay-btn"
            >
              <div className="flex items-center justify-center gap-3">
                <Smartphone className="w-6 h-6" />
                <div className="text-left">
                  <p className="font-bold">Payer avec Kkiapay</p>
                  <p className="text-xs opacity-80">MTN, Moov, Wave, Carte</p>
                </div>
              </div>
            </Button>

            {/* Wallet Option */}
            <Button
              onClick={onWallet}
              disabled={!selectedClient?.phone}
              className="w-full h-16 bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white disabled:opacity-50"
              data-testid="mobile-pay-wallet-btn"
            >
              <div className="flex items-center justify-center gap-3">
                <Wallet className="w-6 h-6" />
                <div className="text-left">
                  <p className="font-bold">Porte-monnaie Client</p>
                  <p className="text-xs opacity-80">
                    {selectedClient?.phone ? `Client: ${selectedClient.name}` : "Sélectionnez un client"}
                  </p>
                </div>
              </div>
            </Button>

            {/* Pay Later Option */}
            <Button
              onClick={onPayLater}
              variant="outline"
              className="w-full h-12 border-slate-600 text-slate-300 hover:bg-slate-700"
              data-testid="mobile-pay-later-btn"
            >
              <Clock className="w-4 h-4 mr-2" />
              Paiement différé (créer la facture)
            </Button>
          </div>

          <Button
            onClick={() => onOpenChange(false)}
            variant="ghost"
            className="w-full text-slate-400 hover:text-white"
            data-testid="mobile-pay-cancel-btn"
          >
            Annuler
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MobilePaymentModal;
